export default __webpack_public_path__ + "static/media/banner_login.d833ec51.jpg";